import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { global } from "@shared/libs/Global";
import { menuInfo } from "@shared/type/CommonType";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnButton from "@shared/components/SnButton";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import {
  ControlledTreeEnvironment,
  Tree,
  TreeItem,
  TreeItemIndex,
  DraggingPosition,
  DraggingPositionBetweenItems,
  DraggingPositionItem,
} from "react-complex-tree";
import "react-complex-tree/lib/style-modern.css";
import _ from "lodash";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}
interface ModifiedNodeInfo {
  isDirty: boolean;
  status: "INSERT" | "UPDATE" | string;
}

interface TreeItemData extends TreeItem {
  index: TreeItemIndex;
  isFolder?: boolean;
  children: TreeItemIndex[];
  // data: any;
  data: {
    title: string;
    originTree?: string;
    [key: string]: any;
  };
  hasChildren?: boolean;
  canMove?: boolean;
  canRename?: boolean;
  isExpanded: boolean;
  modifiedNode?: ModifiedNodeInfo;
}

type TreeData = Record<TreeItemIndex, TreeItemData>;
type OnMoveNodeParams = {
  node: TreeItem;
  treeIndex?: number;
  path?: (string | number)[];
  prevPath?: (string | number)[];
  nextParentNode?: TreeItem | null;
  nextTreeIndex?: number;
};
interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}
const SN_SYS_AUT_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable

  const dragSourceRef = useRef<string | null>(null);
  const { userInfo } = global();
  //#endregion

  //#region  Components useState

  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    tree1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    tree1: [],
    tree2: [],
    tree3: [],
  });
  const [isRoot1, setIsRoot1] = useState<boolean>(false);
  const [isRoot3, setIsRoot3] = useState<boolean>(false);

  const [treeDataSource, setTreeDataSource] = useState<any>();
  const [treeDataSource2, setTreeDataSource2] = useState<any>();
  const [treeDataSource3, setTreeDataSource3] = useState<any>();
  const [treeOriginalData2, setTreeOriginalData2] = useState<any>();
  const treeOriginalData2Ref = useRef<any>();
  const [dragData, setDragData] = useState<any>(null);
  const [OriginalData, setOriginalData] = useState<any>();
  const [volumeDataSource, setVolumeDataSource] = useState<any>();
  const [copyDataSource, setCopyDataSource] = useState<any>();
  const [allExpanded, setAllExpanded] = useState(true);
  const [allExpanded2, setAllExpanded2] = useState(true);
  const [allExpanded3, setAllExpanded3] = useState(true);
  const [gridFocus, setGridFocus] = useState(false);
  const [deletedNodes, setDeletedNodes] = useState<any[]>([]);
  const [expandedItems, setExpandedItems] = useState<TreeItemIndex[]>([
    "root_1",
  ]);
  const [expandedItems2, setExpandedItems2] = useState<TreeItemIndex[]>([
    "root_2",
  ]);
  const [expandedItems3, setExpandedItems3] = useState<TreeItemIndex[]>([]);
  const [mergedItems, setMergedItems] = useState<Record<string, TreeItemData>>(
    {}
  );
  const [contextMenuPos, setContextMenuPos] = React.useState<{
    x: number;
    y: number;
  } | null>(null);
  const [contextMenuNode, setContextMenuNode] = React.useState<any>(null);

  const openContextMenu = (event: React.MouseEvent, node: any) => {
    event.preventDefault();
    // setSelectedItems([node]);
    setContextMenuPos({ x: event.clientX, y: event.clientY });
    setContextMenuNode(node);
  };

  const closeContextMenu = () => {
    setContextMenuPos(null);
    setContextMenuNode(null);
  };

  const [selectedItems, setSelectedItems] = useState<TreeItemIndex[]>([]);
  const [contextMenu, setContextMenu] = useState<{
    x: number;
    y: number;
    nodeId: string | null;
  } | null>(null);

  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_SYS_AUT_REG_001";

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();

        const hidecolumns = rtn.grid.grid2.map((column: any) => {
          if (column.field !== "nm_menu") {
            return {
              ...column,
              hide: true,
            };
          }
          return column;
        });

        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          tree1: hidecolumns,
        });

        await onSearch();
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (treeDataSource?.items) {
      const initiallyExpanded = Object.values(treeDataSource.items)
        .filter((item: any) => item?.isFolder && item?.isExpanded)
        .map((item: any) => item?.index.toString());

      setExpandedItems(initiallyExpanded);
    }
  }, [treeDataSource]);

  useEffect(() => {
    if (treeDataSource2?.items) {
      const initiallyExpanded = Object.values(treeDataSource2.items)
        .filter((item: any) => item?.isFolder && item?.isExpanded)
        .map((item: any) => item?.index.toString());

      setExpandedItems2(initiallyExpanded);
    }
  }, [treeDataSource2]);

  useEffect(() => {
    if (treeDataSource3?.items) {
      const initiallyExpanded = Object.values(treeDataSource3.items)
        .filter((item: any) => item?.isExpanded)
        .map((item: any) => item?.index.toString());

      setExpandedItems3(initiallyExpanded);
    }
  }, [treeDataSource3]);

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
    onInsert,
    onDelete,
  }));

  const onInsert = async () => {
    try {
      const grid1Changes = gridRefs.current["grid1"].current.getChange().insert;

      if (grid1Changes.length > 0) return false;

      const newRow = {
        cd_gpmenu: "",
        nm_gpmenu: "",
        cd_firm: userInfo.cd_firm,
      };
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  //#region onDelete
  const onDelete = async () => {
    try {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedRowNode) return;

      const confirm = await showDialog("confirm", "삭제하시겠습니까?");
      if (!confirm) return;

      const cd_menu = focusedRowNode.data?.cd_gpmenu + userInfo.cd_firm;
      if (!cd_menu) return;

      const idsToDelete = Object.entries(treeDataSource2.items)
        .filter(([nodeId, node]) => {
          const treeNode = node as TreeItemData;
          return treeNode.data?.original?.no_level !== 0 && nodeId !== "root_2";
        })
        .map(([nodeId]) => nodeId);

      // 2. removeFromChildren2 사용하여 DELETE 처리 및 자식 재귀 삭제
      const { newTreeItems, deletedNodes } = removeFromChildren3(
        treeDataSource2.items,
        idsToDelete
      );

      // setState는 UI용으로만
      setDeletedNodes(deletedNodes);

      // --- 트리 삭제 로직 끝 ---

      // 그리드에서 선택 행 삭제
      gridRefs.current["grid1"].current.deleteSelectedRows();

      // 삭제된 행 존재 확인 후 저장 호출
      const realDeletedRows =
        gridRefs.current["grid1"].current.getChange().delete ?? [];
      if (!realDeletedRows.length) {
        gridRefs.current["grid1"].current.resetUpdate();
        return;
      }
      await onSave(deletedNodes ?? []);
    } catch (error) {
      console.error(error);
    }
  };

  //#region onSearch
  const onSearch = async () => {
    const modifiedRows = gridRefs.current["grid1"].current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }

    try {
      const params = {
        id: "sn_sys_aut_reg_001_01",
        params: { cd_firm: userInfo.cd_firm, cd_gpmenu: "" },
      };

      setTreeDataSource([]);
      setTreeDataSource2([]);
      setTreeDataSource3([]);
      setSelectedItems([]);
      setDragData([]);

      const data: any = await fnGetDataSet(params);

      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        tree1: data[2] || [],
        tree2: data[3] || [],
        tree3: data[4] || [],
      });
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      setAllExpanded(false);
      setAllExpanded2(false);
      setAllExpanded3(false);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region onSave
  const onSave = async (deletedNodes: TreeItemData[] = []) => {
    try {
      // 기존 그리드 저장 로직 유지
      // Maintain existing grid save logic
      const changesRow = gridRefs.current["grid1"].current.getChange();

      const changes = applyChangesToOriginal(
        treeOriginalData2Ref.current,
        // treeOriginalData2 || [],
        treeDataSource2 || []
      );

      const {
        insert: insertTree2,
        update: updateTree2,
        deleteNode: deleteTree2,
      } = getDirtyNodesFromTree(changes || []);

      const dirtyTree2Change = {
        modifiedRowcount:
          insertTree2.length + updateTree2.length + deleteTree2.length,
        insert: insertTree2,
        update: updateTree2,
        //delete: deletedNodesData,
        delete: deleteTree2,
      };

      if (
        dirtyTree2Change.modifiedRowcount === 0 &&
        changesRow.modifiedRowcount === 0
      ) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return;
      }

      // 저장 데이터 구성
      const saveData = {
        sys_gpmenu: dirtyTree2Change,
        sys_gpmenuh: changesRow,
      };

      await fnSave("SN_SYS_AUT_REG_001_SAVE_01", saveData);
      gridRefs.current["grid1"].current.resetUpdate();
      // 저장 성공 시 트리의 isDirty 초기화
      // Initialize the tree's isDirty when saving is successful
      clearDirtyFlag(treeDataSource || []);
      clearDirtyFlag(treeDataSource2 || []);
      clearDirtyFlag(treeDataSource3 || []);
      setDeletedNodes([]); // 상태 업데이트 // Status update
      setSelectedItems([]);
      setDragData([]);
      await onSearch();
      return true;
    } catch (error: any) {
      // showDialog("error", error.message);
    }
  };

  function applyChangesToOriginal(
    original: { items: Record<string, any> },
    current: { items: Record<string, any> }
  ) {
    const originalItems = original?.items || {};
    const currentItems = current?.items || {};

    // 1️⃣ 원본 아이템을 cd_menu → node Map으로
    const originalMap: Record<string, any> = {};
    Object.values(originalItems).forEach((node) => {
      const cd_menu = node.data?.original?.cd_menu;
      if (cd_menu) originalMap[cd_menu] = node;
    });

    Object.values(currentItems).forEach((node) => {
      const cd_menu = node.data?.original?.cd_menu;
      if (!cd_menu) return;

      if (!originalMap[cd_menu]) {
        // INSERT
        originalItems[node.index] = {
          ...node,
          modifiedNode: { isDirty: true, status: "INSERT" },
        };
      }
    });

    Object.values(currentItems).forEach((node) => {
      const cd_menu = node.data?.original?.cd_menu;
      if (!cd_menu) return;

      const origNode = originalMap[cd_menu];
      if (!origNode) return; // 원본에 없으면 INSERT에서 처리됨

      const nodeParent = node.data?.original?.cd_menu_parent;
      const origParent = origNode.data?.original?.cd_menu_parent;
      const nodeLevel = node.data?.original?.no_level;
      const nodeSeq = node.data?.original?.no_seq;
      const origLevel = origNode.data?.original?.no_level;
      const origSeq = origNode.data?.original?.no_seq;

      if (
        nodeLevel !== origLevel ||
        nodeSeq !== origSeq ||
        nodeParent !== origParent
      ) {
        // 1️⃣ modifiedNode 상태 추가
        origNode.modifiedNode = { isDirty: true, status: "UPDATE" };

        // 2️⃣ 실제 원본 데이터 업데이트
        origNode.data.original.no_level = nodeLevel;
        origNode.data.original.no_seq = nodeSeq;

        // 필요하면 path나 parent도 업데이트 가능
        origNode.data.original.cd_menu_parent =
          node.data.original.cd_menu_parent;
        origNode.data.original.dc_path = node.data.original.dc_path;
      }
    });

    // 3️⃣ 원본에는 있는데 현재(UI)에 없는 경우 → DELETE
    const currentCdSet = new Set(
      Object.values(currentItems)
        .map((node) => node.data?.original?.cd_menu)
        .filter(Boolean)
    );

    Object.values(originalItems).forEach((origNode) => {
      const cd_menu = origNode.data?.original?.cd_menu;
      if (!cd_menu) return;

      if (!currentCdSet.has(cd_menu)) {
        origNode.modifiedNode = { isDirty: true, status: "DELETE" };
      }
    });

    return original;
  }

  //#region Filter
  const onFocusedRowChanged = async (event: any) => {
    const selectedRow = event;
    const gpMenu = selectedRow.cd_gpmenu || "";
    gridRefs.current["grid2"].current.applyFilters({
      cd_gpmenu: selectedRow.cd_gpmenu,
    });

    if (selectedRow) {
      setTree(gpMenu);
    } else {
      return;
    }
  };

  const setTree = (gpMenu: string) => {
    const filteredTree2 = dataSources.tree2.filter(
      (item: any) => item.cd_gpmenu === gpMenu
    );

    const filteredTree3 = dataSources.tree3.filter(
      (item: any) => item.cd_gpmenu === gpMenu
    );
    const groupMenuData = toComplexTreeData(filteredTree3, "root_1"); // 미할당
    const userMenuData = toComplexTreeData(filteredTree2, "root_2"); // 할당
    const firmMenuData = toComplexTreeData(dataSources.tree1, "root_3");

    const addOriginTreeToItems = (
      items: Record<string, TreeItemData>,
      originTree: string
    ) => {
      const newItems: Record<string, TreeItemData> = {};
      for (const key in items) {
        newItems[key] = {
          ...items[key],
          data: {
            ...items[key].data,
            originTree, // 여기 추가
          },
        };
      }
      return newItems;
    };

    const mergedItems = {
      ...addOriginTreeToItems(groupMenuData.items, "tree1"),
      ...addOriginTreeToItems(userMenuData.items, "tree2"),
      root_1: {
        ...groupMenuData.items["root_1"],
        data: {
          ...groupMenuData.items["root_1"].data,
          originTree: "tree1",
        },
      },
      root_2: {
        ...userMenuData.items["root_2"],
        data: {
          ...userMenuData.items["root_2"].data,
          originTree: "tree2",
        },
      },
      root: {
        index: "root",
        children: ["root_1", "root_2"],
        data: { title: "전체 메뉴" },
        hasChildren: true,
        isFolder: true,
        isExpanded: true,
        canMove: false,
        canRename: false,
      },
    };
    console.log(mergedItems);
    setMergedItems(mergedItems);
    setTreeDataSource(groupMenuData);
    setTreeDataSource2(userMenuData);
    setTreeDataSource3(firmMenuData);
    setTreeOriginalData2(groupMenuData); // 복원용
    const deepCopyGrid2 = JSON.parse(JSON.stringify(userMenuData));
    setTreeOriginalData2(deepCopyGrid2);
    treeOriginalData2Ref.current = deepCopyGrid2;
    setOriginalData(groupMenuData);
  };

  const ChangeGpmenu = (
    oldGpMenu: string,
    gpMenu: string,
    nmMenu1: string,
    nmMenu2: string
  ) => {
    const filteredTree2 = dataSources.tree2
      .filter((item: any) => item.cd_gpmenu === oldGpMenu)
      .map((item: any) => ({
        ...item,
        cd_gpmenu: gpMenu,
        ...(item.cd_menu === "1000" ? { nm_menu: nmMenu1 } : {}),
      }));

    const filteredTree3 = dataSources.tree3
      .filter((item: any) => item.cd_gpmenu === oldGpMenu)
      .map((item: any) => ({
        ...item,
        cd_gpmenu: gpMenu,
        ...(item.cd_menu === "1000" ? { nm_menu: nmMenu2 } : {}),
      }));
    const groupMenuData = toComplexTreeData(filteredTree3, "root_1"); // 미할당
    const userMenuData = toComplexTreeData(filteredTree2, "root_2"); // 할당
    const firmMenuData = toComplexTreeData(dataSources.tree1, "root_3");

    const addOriginTreeToItems = (
      items: Record<string, TreeItemData>,
      originTree: string
    ) => {
      const newItems: Record<string, TreeItemData> = {};
      for (const key in items) {
        newItems[key] = {
          ...items[key],
          data: {
            ...items[key].data,
            originTree, // 여기 추가
          },
        };
      }
      return newItems;
    };

    const mergedItems = {
      ...addOriginTreeToItems(groupMenuData.items, "tree1"),
      ...addOriginTreeToItems(userMenuData.items, "tree2"),
      root_1: {
        ...groupMenuData.items["root_1"],
        data: {
          ...groupMenuData.items["root_1"].data,
          originTree: "tree1",
        },
      },
      root_2: {
        ...userMenuData.items["root_2"],
        data: {
          ...userMenuData.items["root_2"].data,
          originTree: "tree2",
        },
      },
      root: {
        index: "root",
        children: ["root_1", "root_2"],
        data: { title: "전체 메뉴" },
        hasChildren: true,
        isFolder: true,
        isExpanded: true,
        canMove: false,
        canRename: false,
      },
    };
    setMergedItems(mergedItems);
    setTreeDataSource(groupMenuData);
    setTreeDataSource2(userMenuData);
    setTreeDataSource3(firmMenuData);
    setTreeOriginalData2(groupMenuData); // 복원용
    const deepCopyGrid2 = JSON.parse(JSON.stringify(userMenuData));
    setTreeOriginalData2(deepCopyGrid2);
    treeOriginalData2Ref.current = deepCopyGrid2;
    setOriginalData(groupMenuData);
  };

  useEffect(() => {
    if (!treeDataSource?.items || !treeDataSource2?.items) return;

    // const fixedTree1 = fixFolderFlags(treeDataSource.items);
    // const fixedTree2 = fixFolderFlags(treeDataSource2.items);
    const fixedTree1 = treeDataSource.items;
    const fixedTree2 = treeDataSource2.items;

    const merged = {
      ...fixedTree1,
      ...fixedTree2,
      root_1: fixedTree1["root_1"],
      root_2: fixedTree2["root_2"],
      root: {
        index: "root",
        children: ["root_1", "root_2"],
        data: { title: "전체 메뉴" },
        hasChildren: true,
        isFolder: true,
        isExpanded: true,
        canMove: false,
        canRename: false,
      },
    };

    setMergedItems(merged);

    setExpandedItems((prev) =>
      prev.filter(
        (id) => fixedTree1[id] && (fixedTree1[id].children?.length ?? 0) > 0
      )
    );
    setExpandedItems2((prev) =>
      prev.filter(
        (id) => fixedTree2[id] && (fixedTree2[id].children?.length ?? 0) > 0
      )
    );
  }, [treeDataSource, treeDataSource2]);

  const toComplexTreeData = (
    flatData: any[],
    rootId: string
  ): { rootItem: string; items: Record<string, TreeItemData> } => {
    const items: Record<string, TreeItemData> = {};
    const rootChildren: string[] = [];

    // 트리별 프리픽스 설정
    const prefix =
      rootId === "root_1"
        ? "tree1_"
        : rootId === "root_2"
          ? "tree2_"
          : "unknown_";

    flatData.forEach((item) => {
      // id에 프리픽스 붙이기
      const id = prefix + String(item.cd_menu);
      const parentId = item.cd_menu_parent
        ? prefix + String(item.cd_menu_parent)
        : null;

      items[id] = {
        index: id,
        data: {
          title: ` ${item.nm_menu}`,
          subtitle: `레벨: ${item.no_level} / 순서: ${item.no_seq}`,
          // original: item,
          original: {
            ...item,
            no_pos: item.no_pos ?? "000", // 없거나 undefined/null이면 "000"으로
          },
          originTree:
            rootId === "root_1"
              ? "tree1"
              : rootId === "root_2"
                ? "tree2"
                : "unknown",
        },
        children: [],
        isFolder: item.fg_menu === "MGM",
        canMove: true,
        canRename: false,
        isExpanded: item.no_level === 0,
        hasChildren: item.fg_menu === "MGM",
      };

      if (!parentId) {
        rootChildren.push(id);
      } else {
        if (!items[parentId]) {
          items[parentId] = {
            index: parentId,
            data: { title: "(placeholder)" },
            children: [],
            isFolder: true,
            isExpanded: true,
            canMove: true,
            canRename: false,
            hasChildren: true,
          } as TreeItemData;
        }
        items[parentId].children.push(id);
        items[parentId].isFolder = true;
        items[parentId].hasChildren = true;
      }
    });

    items[rootId] = {
      index: rootId,
      data: { title: "Root" },
      children: rootChildren,
      isFolder: true,
      isExpanded: true,
      canMove: false,
      canRename: false,
      hasChildren: rootChildren.length > 0,
    };

    return {
      rootItem: rootId,
      items,
    };
  };

  function getDirtyNodesFromTree(treeItems: { items: Record<string, any> }): {
    insert: any[];
    update: any[];
    deleteNode: any[];
  } {
    const insert: any[] = [];
    const update: any[] = [];
    const deleteNode: any[] = [];
    const pkSet = new Set<string>();

    const items = treeItems.items;

    Object.values(items).forEach((node) => {
      if (!node.data?.original || node.data.original.no_level === 0) return;

      const original = node.modifiedNode || node.data.original;

      if (original?.isDirty) {
        const pkKey = `${node.data?.original.cd_firm}_${node.data?.original.cd_user}_${node.data?.original.cd_menu}`;

        if (!pkSet.has(pkKey)) {
          pkSet.add(pkKey);

          const data = {
            ...node.data?.original,
            cd_menu_parent: removePrefix(node.data?.original.cd_menu_parent),
            dc_path: node.data?.original.dc_path
              ?.split(",")
              .map(removePrefix)
              .join(","),
            fg_select: "1",
            fg_insert: "Y",
            fg_update: "Y",
            fg_delete: "Y",
            fg_excel: "Y",
            fg_print: "Y",
            fg_setup: "Y",
            fg_exconn: "Y",
          };

          if (node.modifiedNode.status === "INSERT") {
            insert.push(data);
          } else if (node.modifiedNode.status === "UPDATE") {
            update.push(data);
          } else if (node.modifiedNode.status === "DELETE") {
            deleteNode.push(data);
          } else {
            console.warn("Unknown status for dirty node:", node.modifiedNode);
          }
        } else {
        }
      }
    });

    return { insert, update, deleteNode };
  }

  function removePrefix(id: string | undefined): string | undefined {
    if (!id) return id;
    return id.replace(/^(tree1_|tree2_)/, "");
  }

  // 저장 후 isDirty 초기화
  function clearDirtyFlag(treeDataSource: { items: Record<string, any> }) {
    const items = treeDataSource.items;

    Object.values(items).forEach((node) => {
      if (node.data?.original) {
        node.data.original.isDirty = false;
        node.data.original.status = ""; // 상태 초기화
      }
      if (node.modifiedNode) {
        node.modifiedNode.isDirty = false;
        node.modifiedNode.status = "";
      }
    });
  }

  const handleDropToTree2 = async (
    draggedItems: TreeItemData[],
    target: any, // DraggingPosition (any로 받아서 안전하게 검사)
    tree2Items: TreeData,
    setTree2Wrapper: (newState: any) => void,
    tree1Items: TreeData,
    setTree1Wrapper: (newState: any) => void
  ) => {
    if (!draggedItems || draggedItems.length === 0) return;

    if (
      target.parentItem &&
      target.parentItem.includes("root") &&
      target.targetType == "between-items"
    ) {
      await showDialog(
        "alter",
        "해당 레벨로는 권한을 추가 할 수 없습니다. \n하위레벨로 추가해주시기 바랍니다."
      );
      return; // "root"라는 글자가 포함되어 있으면 종료
    }

    const draggedIds: TreeItemIndex[] = draggedItems.map((it) => it.index);
    const fromTree1 = draggedItems.some((it) => it.data.originTree === "tree1");
    const fromTree2 = draggedItems.some((it) => it.data.originTree === "tree2");

    // ------------------ 드래그 이동 처리 ------------------
    if (fromTree1 && !fromTree2) {
      const draggedCdMenus = draggedItems.map(
        (item) => item.data.original.cd_menu
      );

      const getNodeAndAllChildren = (
        treeItems: TreeData,
        node: TreeItemData
      ): TreeItemData[] => {
        let result: TreeItemData[] = [node]; // 자기 자신 포함

        (node.children || []).forEach((childId) => {
          const childNode = treeItems[childId];
          if (childNode) {
            result = result.concat(getNodeAndAllChildren(treeItems, childNode));
          }
        });

        return result;
      };

      // handleDropToTree2 안에서
      if (!draggedItems || draggedItems.length === 0) return;

      // 1️⃣ 선택한 노드 + 자식들 모두 찾아서 dragData용 배열 생성
      let allNodesToDrag: TreeItemData[] = [];
      draggedItems.forEach((item) => {
        const nodesWithChildren = getNodeAndAllChildren(tree1Items, item);
        allNodesToDrag = allNodesToDrag.concat(nodesWithChildren);
      });

      // 2️⃣ dragData에 중복 없이 누적
      const prevDragData = dragData || [];
      const newDragData = [
        ...prevDragData,
        ...allNodesToDrag.filter(
          (item) => !prevDragData.some((e: any) => e.index === item.index)
        ),
      ];

      // 3️⃣ 상태 업데이트
      setDragData(newDragData);
      const duplicateNode = Object.values(tree2Items).find((node: any) =>
        draggedCdMenus.includes(node.data?.original?.cd_menu)
      );

      if (duplicateNode) {
        await showDialog("alter", "이미 등록된 메뉴입니다.");
        return;
      }

      const preservedExpandedItems = [...expandedItems];
      const preservedExpandedItems2 = [...expandedItems2];
      const newTree1 = cloneTree(tree1Items);
      const newTree2 = cloneTree(tree2Items);

      // tree1에서 제거
      removeFromChildren(newTree1, draggedIds);

      draggedIds.forEach((id) => {
        deepCopyNodeAndChildren(tree1Items, newTree2, id, "tree2");
      });

      const { parentId, position } = resolveTargetParentAndPosition(
        target,
        newTree2
      );

      const newDraggedIds = draggedIds.map((id) =>
        typeof id === "string" ? id.replace("tree1", "tree2") : id
      );

      insertIntoChildren(newTree2, parentId, newDraggedIds, position);

      const affectedNodes = getAllDescendantIds(newTree2, newDraggedIds);
      recalcLevelsAndSeq(newTree2, "root_2", "INSERT", [], affectedNodes);
      // recalcLevelsAndSeq(newTree2, "root_2", "INSERT");
      updateDcPathRecursive(newTree2, "root_2");

      preservedExpandedItems.forEach((id) => {
        if (newTree1[id]) {
          newTree1[id].isExpanded = true;
        }
      });
      preservedExpandedItems2.forEach((id) => {
        if (newTree2[id]) {
          newTree2[id].isExpanded = true;
        }
      });
      setTree1Wrapper((prev: any) => ({ ...(prev || {}), items: newTree1 }));
      setTree2Wrapper((prev: any) => ({ ...(prev || {}), items: newTree2 }));
      setExpandedItems(preservedExpandedItems);
      setExpandedItems2(preservedExpandedItems2);
      return;
    }

    if (!fromTree1 && fromTree2) {
      const preservedExpandedItems2 = [...expandedItems2];
      const newTree2 = cloneTree(tree2Items);

      const { parentId, position } = resolveTargetParentAndPosition(
        target,
        newTree2
      );

      const nodesToMove = draggedIds.map((id) => {
        const node = { ...newTree2[id] }; // 객체 복사
        if (node.data?.original) {
          node.data.original.cd_menu_parent = parentId;
        }
        return node;
      });

      // 기존 children에서 드래그된 아이템 제거
      removeFromChildren(newTree2, draggedIds);

      // 자기 자신의 하위에 드롭 방지
      for (const draggedId of draggedIds) {
        const ancestorCheck = (candidate: TreeItemIndex | null): boolean => {
          if (!candidate) return false;
          if (candidate === draggedId) return true;
          // climb up
          const p = findParent(newTree2, candidate);
          return ancestorCheck(p);
        };
        if (ancestorCheck(parentId)) {
          console.warn(
            "Cannot drop into its own descendant. Ignoring move.",
            draggedId,
            parentId
          );
          return;
        }
      }
      nodesToMove.forEach((node) => {
        newTree2[node.index] = node; // 트리 객체에 다시 등록
      });
      insertIntoChildren(newTree2, parentId, draggedIds, position);

      const affectedNodes = getAllDescendantIds(newTree2, draggedIds);

      const isInsertMode = draggedIds.some(
        (id) => !treeOriginalData2?.items?.[id]
      );

      if (isInsertMode) {
        recalcLevelsAndSeq(newTree2, "root_2", "INSERT", [], affectedNodes);
      } else {
        recalcLevelsAndSeq(newTree2, "root_2", "UPDATE", [], affectedNodes);
      }

      updateDcPathRecursive(newTree2, "root_2");
      preservedExpandedItems2.forEach((id) => {
        if (newTree2[id]) {
          newTree2[id].isExpanded = true;
        }
      });
      setTree2Wrapper((prev: any) => ({ ...(prev || {}), items: newTree2 }));
      setExpandedItems2(preservedExpandedItems2);
    }
  };

  const cloneTree = (items: TreeData): TreeData => {
    const copy: TreeData = {};
    Object.entries(items || {}).forEach(([k, v]) => {
      copy[k] = {
        ...(v as any),
        children: Array.isArray(v.children) ? [...v.children] : [],
      };
    });
    return copy;
  };

  const removeFromChildren = (treeItems: TreeData, ids: TreeItemIndex[]) => {
    // ids에 부모와 자식 모두 포함되도록 확장
    const allIds = new Set<TreeItemIndex>();

    const addDescendants = (id: TreeItemIndex) => {
      allIds.add(id);
      const node = treeItems[id];
      if (node?.children) {
        node.children.forEach((childId) => addDescendants(childId));
      }
    };

    ids.forEach((id) => addDescendants(id));

    // 1️⃣ 부모 children 배열에서 제거
    Object.values(treeItems).forEach((item) => {
      if (item.children) {
        item.children = item.children.filter((childId) => !allIds.has(childId));
      }
    });

    // 2️⃣ treeItems에서 노드 자체 삭제
    allIds.forEach((id) => {
      delete treeItems[id];
    });
  };

  const insertIntoChildren = (
    treeItems: TreeData,
    parentId: TreeItemIndex | null,
    ids: TreeItemIndex[],
    position?: number
  ) => {
    const pid = parentId ?? "root_2";
    if (!treeItems[pid]) {
      return;
    }
    if (!treeItems[pid].children) treeItems[pid].children = [];

    // 중복 제거
    treeItems[pid].children = treeItems[pid].children.filter(
      (id) => !ids.includes(id)
    );

    let insertIndex = treeItems[pid].children.length;
    if (typeof position === "number" && position >= 0) {
      insertIndex = Math.min(position, treeItems[pid].children.length);
    }

    treeItems[pid].children.splice(insertIndex, 0, ...ids);
  };

  // helper: 특정 childId의 직접 부모를 찾아 반환 (없으면 null)
  const findParent = (
    treeItems: TreeData,
    childId: TreeItemIndex
  ): TreeItemIndex | null => {
    for (const [key, val] of Object.entries(treeItems)) {
      if (Array.isArray(val.children) && val.children.indexOf(childId) !== -1) {
        return key;
      }
    }
    return null;
  };

  // 레벨과 순서 재계산
  const recalcLevelsAndSeq = (
    treeItems: TreeData,
    rootId: TreeItemIndex,
    status: string | null = null, // null이면 상태 변경 안 함
    parentPath: string[] = [],
    affectedNodes: Set<TreeItemIndex> | null = null // 상태 변경할 노드 집합
  ) => {
    const dfs = (
      nodeId: TreeItemIndex,
      parentId: TreeItemIndex | null,
      level: number
    ) => {
      const node = treeItems[nodeId];
      if (!node) return;

      const parent = parentId ? treeItems[parentId] : null;
      const siblings = parent
        ? parent.children
        : treeItems[rootId]?.children || [];
      const order = siblings.indexOf(nodeId);

      node.data.original.no_level = level;
      node.data.original.cd_menu_parent = parentId;
      node.data.original.no_seq = order + 1;

      (node.children || []).forEach((childId) => {
        dfs(childId, nodeId, level + 1);
      });
    };

    (treeItems[rootId]?.children || []).forEach((childId) =>
      dfs(childId, rootId, 0)
    );
  };
  // -------------- 부모 ID와 position(위치) 계산 로직 --------------
  // 목적:
  // - 아이템 "위에" 드롭 (targetType === 'on-item' / 'on-folder') → parentId = 해당 아이템
  // - 아이템 "사이"에 드롭 → parentId = 타겟 아이템의 부모
  // - childIndex가 제공되면 그 값을 position으로 사용
  // - 위 정보가 없으면 findParent로 부모를 찾아서 처리
  const resolveTargetParentAndPosition = (
    targetObj: any,
    treeItems: TreeData
  ): { parentId: TreeItemIndex | null; position: number | undefined } => {
    let parentId: TreeItemIndex | null = null;
    let position: number | undefined = undefined;

    const tt: string | undefined =
      targetObj?.targetType || targetObj?.type || undefined;
    const targetItem: string | undefined =
      targetObj?.targetItem ??
      targetObj?.item ??
      targetObj?.target ??
      undefined;
    const parentItemField: string | undefined =
      targetObj?.parentItem ?? undefined;
    const childIndexField: number | undefined =
      typeof targetObj?.childIndex === "number"
        ? targetObj.childIndex
        : undefined;
    const linePosition: string | undefined =
      targetObj?.linePosition ?? undefined;

    // 1) 우선순위: childIndex가 있으면 position으로 사용
    if (typeof childIndexField === "number") {
      position = childIndexField;
    } else if (typeof targetObj?.position === "number") {
      position = targetObj.position;
    }

    if (tt) {
      const t = tt.toString();

      if (t === "item" || t === "on-item") {
        // 'item' 또는 'on-item' 일 때는 targetItem을 부모로 쓰자
        parentId = targetItem ?? null;
        if (
          position === undefined &&
          parentId &&
          treeItems[parentId] &&
          Array.isArray(treeItems[parentId].children)
        ) {
          position = treeItems[parentId].children.length;
        }
      } else if (t === "on-folder") {
        parentId = targetItem ?? parentItemField ?? null;
        if (
          position === undefined &&
          parentId &&
          treeItems[parentId] &&
          Array.isArray(treeItems[parentId].children)
        ) {
          position = treeItems[parentId].children.length;
        }
      } else if (t.startsWith("on")) {
        parentId = targetItem ?? parentItemField ?? null;
        if (
          position === undefined &&
          parentId &&
          treeItems[parentId] &&
          Array.isArray(treeItems[parentId].children)
        ) {
          position = treeItems[parentId].children.length;
        }
      } else if (t.includes("between")) {
        parentId = parentItemField ?? null;

        if (position === undefined) {
          if (targetItem) {
            const p = parentItemField ?? findParent(treeItems, targetItem);
            if (p && treeItems[p]) {
              const idx = treeItems[p].children.indexOf(targetItem);
              position = idx + (linePosition === "bottom" ? 1 : 0);
            }
          }
        }
      } else {
        parentId = parentItemField ?? targetItem ?? null;
        if (
          position === undefined &&
          parentId &&
          treeItems[parentId] &&
          Array.isArray(treeItems[parentId].children)
        ) {
          position = treeItems[parentId].children.length;
        }
      }
      // 기타 알 수 없는 타입 처리
    } else {
      // targetType이 없을 경우 fallback 처리
      if (parentItemField) {
        parentId = parentItemField;
      } else if (targetItem) {
        const p = findParent(treeItems, targetItem);
        if (p) {
          parentId = p;
          if (position === undefined) {
            position =
              treeItems[p].children.indexOf(targetItem) +
              (linePosition === "bottom" ? 1 : 0);
          }
        } else {
          parentId = "root_2"; // 최종 fallback
        }
      } else {
        parentId = "root_2"; // 최종 fallback
      }
    }

    // parentId가 undefined일 경우 최종 fallback
    if (parentId === undefined || parentId === null) {
      parentId = "root_2";
    }

    return { parentId, position };
  };

  const deepCopyNodeAndChildren = (
    sourceTree: TreeData,
    newTree: TreeData,
    nodeId: TreeItemIndex,
    newOriginTree: string
  ) => {
    const node = sourceTree[nodeId];
    if (!node) return;

    // 1️⃣ index(tree ID) 교체
    const newId =
      typeof nodeId === "string" ? nodeId.replace("tree1", "tree2") : nodeId;

    // 2️⃣ children ID 교체
    const newChildren: TreeItemIndex[] = (node.children || []).map((childId) =>
      typeof childId === "string" ? childId.replace("tree1", "tree2") : childId
    );

    // 3️⃣ original 깊은 복사
    const originalCopy = JSON.parse(JSON.stringify(node.data.original || {}));

    // 4️⃣ 새로운 노드 추가
    newTree[newId] = {
      ...node,
      index: newId,
      data: {
        ...node.data,
        originTree: newOriginTree,
        original: originalCopy,
      },
      children: newChildren,
    };

    // 5️⃣ 재귀적으로 자식 처리
    (node.children || []).forEach((childId) => {
      deepCopyNodeAndChildren(sourceTree, newTree, childId, newOriginTree);
    });
  };

  function getAllDescendantIds(
    treeItems: TreeData,
    nodeIds: TreeItemIndex[]
  ): Set<TreeItemIndex> {
    const allIds = new Set<TreeItemIndex>();

    function collectDescendants(id: TreeItemIndex) {
      if (allIds.has(id)) return;
      allIds.add(id);
      const node = treeItems[id];
      if (node?.children) {
        node.children.forEach(collectDescendants);
      }
    }

    nodeIds.forEach(collectDescendants);
    return allIds;
  }

  const updateDcPathRecursive = (
    treeItems: TreeData,
    nodeId: TreeItemIndex,
    parentPath: string[] = []
  ) => {
    const node = treeItems[nodeId];
    if (!node) return;

    let currentPath = parentPath;

    // original이 있는 경우만 dc_path 계산
    if (node.data?.original && node.data.original.no_level !== 0) {
      const currentCdMenu = node.data.original.cd_menu ?? "";
      currentPath = [...parentPath, currentCdMenu];
      node.data.original.dc_path = currentPath.join(",");
    }

    // 자식은 무조건 순회
    (node.children || []).forEach((childId) =>
      updateDcPathRecursive(treeItems, childId, currentPath)
    );
  };

  const onDeleteRow = (nodeId: string | number) => {
    // 삭제 대상 노드와 자식들
    const allIdsToDelete = new Set<TreeItemIndex>();
    getAllDescendants(treeDataSource2.items, nodeId).forEach((id) =>
      allIdsToDelete.add(id)
    );
    allIdsToDelete.add(nodeId);

    // 1️⃣ treeDataSource2 복사

    const updatedTree = _.cloneDeep(treeDataSource2.items);

    // 2️⃣ 각 노드에 modifiedNode 상태 추가 & 삭제
    allIdsToDelete.forEach((id) => {
      if (updatedTree[id]) {
        updatedTree[id] = {
          ...updatedTree[id],
        };
        delete updatedTree[id];
      }
    });

    // 3️⃣ 자식 배열 업데이트
    Object.values(updatedTree).forEach((item) => {
      if ((item as TreeItemData).children) {
        (item as TreeItemData).children = (
          item as TreeItemData
        ).children.filter((childId: any) => !allIdsToDelete.has(childId));
      }
    });

    restoreDeletedNodes(Array.from(allIdsToDelete));

    const preservedExpandedItems = expandedItems.filter(
      (id) => treeDataSource.items[id] // 삭제되지 않은 노드만
    );

    preservedExpandedItems.forEach((id) => {
      if (OriginalData.items[id]) {
        OriginalData.items[id].isExpanded = true;
      }
    });

    // 4️⃣ 열린 상태 보존
    const preservedExpandedItems2 = expandedItems2.filter(
      (id) => updatedTree[id]
    );
    preservedExpandedItems2.forEach((id) => {
      if (updatedTree[id]) updatedTree[id].isExpanded = true;
    });

    // 5️⃣ 상태 반영
    setTreeDataSource2((prev: any) => ({ ...prev, items: updatedTree }));
    setExpandedItems2(preservedExpandedItems2);
  };

  const restoreDeletedNodes = (deletedNodeIds: TreeItemIndex[]) => {
    const updatedTree1 = _.cloneDeep(treeDataSource.items);
    // ✅ 부모까지 역재귀 복원 함수
    const restoreWithParents = (node: any, expandParent: boolean = true) => {
      // 1️⃣ 노드 복원
      if (!updatedTree1[node.index]) {
        updatedTree1[node.index] = _.cloneDeep(node);
      }

      // 2️⃣ 부모 찾기
      const parentCdMenu = node?.data?.original?.cd_menu_parent;
      if (!parentCdMenu) return; // 루트면 종료

      const parentNode =
        dragData.find(
          (item: any) => item?.data?.original?.cd_menu === parentCdMenu
        ) ??
        Object.values(updatedTree1).find(
          (item: any) => item?.data?.original?.cd_menu === parentCdMenu
        );
      Object.values(treeDataSource3).find(
        (item: any) => item?.data?.original?.cd_menu === parentCdMenu
      );

      if (!parentNode) return;

      const parentIndex =
        typeof parentNode.index === "string"
          ? // ? parentNode.index.replace("tree2", "tree1")
            parentNode.index.replace(/^(tree2_|unknown_)/, "")
          : parentNode.index;

      // 3️⃣ 부모 복원 (없으면)
      if (!updatedTree1[parentIndex]) {
        updatedTree1[parentIndex] = _.cloneDeep(parentNode);
      }

      // 4️⃣ 부모.children 연결
      const parent = updatedTree1[parentIndex] as any;
      parent.children = parent.children || [];

      // 이미 있으면 중복 추가 안함
      if (!parent.children.includes(node.index)) {
        // 🔑 복원할 노드의 no_seq
        const nodeSeq = node?.data?.original?.no_seq;

        // 🔑 children에 삽입할 위치 찾기
        let insertIndex = parent.children.length; // 기본: 맨 뒤
        for (let i = 0; i < parent.children.length; i++) {
          const childId = parent.children[i];
          const childNode = updatedTree1[childId];
          if (childNode) {
            const childSeq = childNode?.data?.original?.no_seq;
            if (nodeSeq < childSeq) {
              insertIndex = i;
              break;
            }
          }
        }

        // 🔑 원하는 위치에 삽입
        parent.children.splice(insertIndex, 0, node.index);
      }
      // parent.isExpanded = true;
      // 5️⃣ 부모의 부모도 재귀 처리
      restoreWithParents(parent);
    };

    // ✅ 삭제된 노드들 복원 시작
    deletedNodeIds.forEach((deletedId) => {
      const tree1Index =
        typeof deletedId === "string"
          ? deletedId.replace("tree2", "tree1")
          : deletedId;

      let deletedNode: any;
      deletedNode = dragData?.find((item: any) => item.index === tree1Index);
      if (deletedNode) {
      } else {
        // 2️⃣ treeDataSource3에서 찾기
        deletedNode = Object.values(treeDataSource3?.items).find(
          (item: any) => {
            const cleanItemIndex =
              typeof item.index === "string"
                ? item.index.replace(/^unknown_/, "")
                : item.index;
            const cleanTree1Index =
              typeof tree1Index === "string"
                ? tree1Index.replace(/^tree1_/, "")
                : tree1Index;
            return cleanItemIndex === cleanTree1Index;
          }
        );
        if (deletedNode) {
          if (typeof deletedNode.index === "string") {
            deletedNode.index = deletedNode.index.replace(
              /^unknown_/,
              "tree1_"
            );
          }

          if (Array.isArray(deletedNode.children)) {
            deletedNode.children = deletedNode.children.map((childId: string) =>
              childId.replace(/^unknown_/, "tree1_")
            );
          }

          if (deletedNode.data) {
            deletedNode.data.originTree = "tree1";
          }
        }
      }
      if (deletedNode) restoreWithParents(deletedNode);
    });

    // ✅ children 정리 (안전하게)
    Object.values(updatedTree1).forEach((item: any) => {
      if (!item.children) item.children = [];
      item.children = item.children.filter(
        (childId: any) => updatedTree1[childId]
      );
    });
    selectedItems.forEach((node: any) => {
      const tree1Index =
        typeof node === "string" ? node.replace("tree2", "tree1") : node;

      let currentNode = updatedTree1[tree1Index];
      if (!currentNode) return;

      while (true) {
        const parentCdMenu = currentNode?.data?.original?.cd_menu_parent;
        if (!parentCdMenu) break;

        const parentNode = Object.values(updatedTree1).find(
          (item: any) => item?.data?.original?.cd_menu === parentCdMenu
        );
        if (!parentNode) break;

        currentNode = parentNode;
        currentNode.isExpanded = true; // 부모만 열림 처리
      }
    });
    setTreeDataSource((prev: any) => ({
      ...prev,
      items: updatedTree1,
    }));
  };

  const getAllDescendants = (
    treeItems: TreeData,
    id: TreeItemIndex
  ): TreeItemIndex[] => {
    const node = treeItems[id];
    if (!node || !node.children) return [];
    return node.children.reduce(
      (acc, childId) => [
        ...acc,
        childId,
        ...getAllDescendants(treeItems, childId),
      ],
      [] as TreeItemIndex[]
    );
  };

  //#region InitNewRowH
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const grid1Changes = gridRefs.current["grid1"].current.getChange().insert;

      if (grid1Changes.length > 0) return false;

      const updatedRow = {
        cd_gpmenu: "",
        nm_gpmenu: "",
        cd_firm: userInfo.cd_firm,
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  const onCellValueChangedH = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const newValue = event.newValue;
    const rowData = event.rowData;
    const nm_menu1 = `${rowData.nm_gpmenu || ""}[${rowData.cd_gpmenu || ""}]할당 메뉴`;
    const nm_menu2 = `${rowData.nm_gpmenu || ""}[${rowData.cd_gpmenu || ""}]비할당 메뉴`;
    switch (colId) {
      case "nm_gpmenu":
      case "cd_gpmenu":
        ChangeGpmenu("", rowData.cd_gpmenu, nm_menu1, nm_menu2);
        /*
        setMergedItems((prev: any) => {
          if (!prev?.items?.tree1_1000?.data) return prev;

          return {
            ...prev,
            items: {
              ...prev.items,
              tree1_1000: {
                ...prev.items.tree1_1000,
                data: {
                  ...prev.items.tree1_1000.data,
                  title: nm_menu1,
                },
              },
              tree2_1000: {
                ...prev.items.tree1_1000,
                data: {
                  ...prev.items.tree1_1000.data,
                  title: nm_menu2,
                },
              },
            },
          };
        });
        */
        break;
    }
  };

  const toggleAll = (treeKey: "tree1" | "tree2" | "tree3") => {
    let items: Record<string, TreeItem> = {};
    let expand = false;

    if (treeKey === "tree1") {
      items = treeDataSource.items as Record<string, TreeItem>;
      expand = !allExpanded;
    } else if (treeKey === "tree2") {
      items = treeDataSource2.items as Record<string, TreeItem>;
      expand = !allExpanded2;
    } else if (treeKey === "tree3") {
      items = treeDataSource3.items as Record<string, TreeItem>;
      expand = !allExpanded3;
    }

    const newItems: Record<string, any> = {};

    Object.entries(items).forEach(([key, node]) => {
      const shouldKeepExpanded = !expand && node.data?.original?.no_level === 0;

      newItems[key] = {
        ...node,
        isExpanded: shouldKeepExpanded || expand,
      };
    });

    // 트리별로 set
    if (treeKey === "tree1") {
      setTreeDataSource((prev: any) => ({ ...prev, items: newItems }));
      setAllExpanded(expand);
    } else if (treeKey === "tree2") {
      setTreeDataSource2((prev: any) => ({ ...prev, items: newItems }));
      setAllExpanded2(expand);
    } else if (treeKey === "tree3") {
      setTreeDataSource3((prev: any) => ({ ...prev, items: newItems }));
      setAllExpanded3(expand);
    }
  };

  const reset = async () => {
    const gridview1RowCount =
      gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (gridview1RowCount <= 0) return;
    const result = await showDialog("confirm", "전권해제 하시겠습니까?");
    if (!result) return;
    const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
    const param = {
      cd_firm: userInfo.cd_firm,
      cd_gpmenu: focusedRowNode.data.cd_gpmenu,
    };
    await callApi("SN_SYS_AUT_REG_001_DELETE", param);
    await onSearch();
  };

  const copyPermissions = async () => {
    const result = await showDialog("confirm", "권한복사 하시겠습니까?");
    if (!result) return;

    if (!treeDataSource2) return;

    const copiedItems: TreeData = {};

    const recursiveCopy = (treeItems: TreeData, nodeId: TreeItemIndex) => {
      const node = treeItems[nodeId];
      if (!node) return;

      // 레벨 0 제외
      if (node.data?.original?.no_level !== 0) {
        copiedItems[nodeId] = {
          ...node,
          modifiedNode: { isDirty: true, status: "INSERT" },
        };
      }

      // 자식 재귀
      (node.children || []).forEach((childId) =>
        recursiveCopy(treeItems, childId)
      );
    };

    // root부터 순회
    updateDcPathRecursive(treeDataSource2.items, "root_2"); // 경로 계산용
    (treeDataSource2.items["root_2"].children || []).forEach((childId: any) =>
      recursiveCopy(treeDataSource2.items, childId)
    );

    setCopyDataSource({ ...treeDataSource2, items: copiedItems });

    await showDialog("success", "복사되었습니다.");
  };

  const removeFromChildren2 = (
    treeItems: TreeData,
    ids: TreeItemIndex[],
    setDeletedNodes: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
    const deleted: TreeItemData[] = [];

    const markDeleted = (node: TreeItemData) => {
      const clonedNode = {
        ...node,
        modifiedNode: { isDirty: true, status: "DELETE" },
      };
      deleted.push(clonedNode);

      if (node.children?.length) {
        node.children.forEach((childId) => {
          const childNode = treeItems[childId];
          if (childNode) markDeleted(childNode);
        });
      }
    };

    ids.forEach((id) => {
      const node = treeItems[id];
      if (node) markDeleted(node);
    });

    // 부모 children 필터링 (원본 복제)
    const newTreeItems: TreeData = { ...treeItems };
    Object.values(newTreeItems).forEach((item) => {
      if (item.children) {
        item.children = item.children.filter(
          (childId) => !ids.includes(childId)
        );
      }
    });

    setDeletedNodes((prev) => [...prev, ...deleted]);
    return newTreeItems;
  };

  const removeFromChildren3 = (
    treeItems: TreeData,
    ids: TreeItemIndex[]
  ): { newTreeItems: TreeData; deletedNodes: TreeItemData[] } => {
    const deleted: TreeItemData[] = [];

    const markDeleted = (node: TreeItemData) => {
      const clonedNode = {
        ...node,
        modifiedNode: { isDirty: true, status: "DELETE" },
      };
      deleted.push(clonedNode);

      node.children?.forEach((childId) => {
        const childNode = treeItems[childId];
        if (childNode) markDeleted(childNode);
      });
    };

    ids.forEach((id) => {
      const node = treeItems[id];
      if (node) markDeleted(node);
    });

    // 부모 children 필터링
    const newTreeItems: TreeData = { ...treeItems };
    Object.values(newTreeItems).forEach((item) => {
      if (item.children) {
        item.children = item.children.filter(
          (childId) => !ids.includes(childId)
        );
      }
    });

    return { newTreeItems, deletedNodes: deleted };
  };

  const assignAllPermissions = async () => {
    if (!treeDataSource2 || !treeDataSource) return;

    const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
    if (!focusedRowNode) return;

    const cd_user = focusedRowNode.data?.cd_user;
    const cd_firm = userInfo.cd_firm;
    const parentId = `tree2_${cd_firm}${cd_user}`;

    // 1️⃣ treeDataSource에서 권한 복사 (레벨0 제외)
    const copiedItems: TreeData = {};
    const recursiveCopy = (treeItems: TreeData, nodeId: TreeItemIndex) => {
      const node = treeItems[nodeId];
      if (!node) return;

      if ((node.data?.original?.no_level ?? 0) !== 0) {
        copiedItems[nodeId] = {
          ...node,
          modifiedNode: { isDirty: true, status: "INSERT" },
        };
      }

      (node.children || []).forEach((childId) =>
        recursiveCopy(treeItems, childId)
      );
    };

    // root_1부터 복사 시작
    updateDcPathRecursive(treeDataSource.items, "root_1");
    (treeDataSource.items["root_1"].children || []).forEach((childId: any) =>
      recursiveCopy(treeDataSource.items, childId)
    );

    setVolumeDataSource({ ...treeDataSource, items: copiedItems });

    // 2️⃣ 기존 treeDataSource2에 레벨1 이상 노드가 있는지 확인
    const hasNonZeroLevel = Object.entries(treeDataSource2.items).some(
      ([nodeId, node]: [string, any]) =>
        nodeId !== "root_2" && (node.data.original?.no_level ?? 0) > 0
    );

    let newItems: TreeData = { ...treeDataSource2.items };

    if (hasNonZeroLevel) {
      const confirmResult = await showDialog(
        "confirm",
        "이미 부여된 메뉴권한이 존재합니다. 초기화 후 진행하시겠습니까?"
      );
      if (!confirmResult) return;

      const idsToDelete = Object.entries(treeDataSource2.items)
        .filter(
          ([nodeId, node]: [string, any]) =>
            nodeId !== "root_2" && (node.data.original?.no_level ?? 0) > 0
        )
        .map(([nodeId]) => nodeId);

      newItems = removeFromChildren2(
        treeDataSource2.items,
        idsToDelete,
        setDeletedNodes
      );
    }

    // 3️⃣ 복사한 권한을 treeDataSource2에 붙여넣기
    const pastedNodeIds = Object.keys(copiedItems);

    // 루트(root_2) children 업데이트 (레벨0 유지 + 새로 붙여넣기)
    const level0Nodes = pastedNodeIds.filter(
      (id) => copiedItems[id]?.data.original?.no_level === 0
    );

    const newRootChildren = [
      ...(newItems["root_2"].children ?? []).filter(
        (id: any) => newItems[id]?.data.original?.no_level === 0
      ),
      ...level0Nodes,
    ];

    newItems = {
      ...newItems,
      ...copiedItems, // 붙여넣기 아이템 추가
      root_2: {
        ...newItems["root_2"],
        children: newRootChildren,
      },
    };

    // 레벨1 이상의 노드들은 선택한 사용자 노드(parentId) children에 추가
    pastedNodeIds.forEach((id) => {
      const node = copiedItems[id];
      if ((node.data?.original?.no_level ?? 0) === 1 && newItems[parentId]) {
        newItems[parentId] = {
          ...newItems[parentId],
          children: [...(newItems[parentId].children ?? []), id],
        };
      }
    });

    // 모든 노드 cd_user 업데이트
    pastedNodeIds.forEach((id) => {
      if (newItems[id]) {
        newItems[id] = {
          ...newItems[id],
          data: {
            ...newItems[id].data,
            original: {
              ...newItems[id].data.original,
              cd_user,
            },
          },
        };
      }
    });
    const removeFromChildren = (treeItems: TreeData, ids: TreeItemIndex[]) => {
      Object.values(treeItems).forEach((item) => {
        if (item.children) {
          item.children = item.children.filter(
            (childId) => !ids.includes(childId)
          );
        }
      });
    };
    removeFromChildren(treeDataSource.items, pastedNodeIds);
    // 4️⃣ 최종 업데이트
    setTreeDataSource2({ ...treeDataSource2, items: newItems });
    await showDialog("success", "전권설정 완료되었습니다.");

    // 임시 volumeDataSource 초기화
    setVolumeDataSource([]);
  };

  useEffect(() => {}, [treeDataSource]);
  useEffect(() => {}, [treeDataSource2]);

  const pastePermissions = async (copyDataSource: { items: TreeData }) => {
    if (!treeDataSource2 || !copyDataSource) return;

    const hasNonZeroLevel = Object.entries(treeDataSource2.items).some(
      ([nodeId, node]: [string, any]) =>
        nodeId !== "root_2" && (node.data.original?.no_level ?? 0) > 0
    );

    if (hasNonZeroLevel) {
      const result = await showDialog(
        "confirm",
        "이미 부여된 메뉴권한이 존재합니다. 초기화 후 진행하시겠습니까?"
      );
      if (!result) return;
      const idsToDelete = Object.entries(treeDataSource2.items)
        .filter(([nodeId, node]) => {
          const treeNode = node as TreeItemData;
          return treeNode.data?.original?.no_level !== 0 && nodeId !== "root_2";
        })
        .map(([nodeId]) => nodeId);

      // 2. removeFromChildren2 사용하여 DELETE 처리 및 자식 재귀 삭제
      const newItems = removeFromChildren2(
        treeDataSource2.items,
        idsToDelete,
        setDeletedNodes
      );
    }
    setTreeDataSource2((prev: any) => {
      const pastedNodeIds = Object.keys(copyDataSource.items);
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      const cd_firm = userInfo.cd_firm;
      const cd_user = focusedRowNode?.data?.cd_user;
      const parentId = `tree2_${cd_firm}${cd_user}`;

      // 1️⃣ 루트(root_2) children에는 기존 레벨0 유지 + 붙여넣기 레벨0 추가
      const level0Nodes = pastedNodeIds.filter(
        (id) => copyDataSource.items[id].data?.original?.no_level === 0
      );

      const newRootChildren = [
        ...(prev.items["root_2"].children ?? []).filter(
          (id: string) => prev.items[id]?.data?.original?.no_level === 0
        ),
        ...level0Nodes,
      ];

      // 2️⃣ 기존 items와 붙여넣기 items 합치기
      const newItems: TreeData = {
        ...prev.items, // 기존 items 유지
        ...copyDataSource.items, // 붙여넣기 아이템 추가
        root_2: {
          ...prev.items["root_2"],
          children: newRootChildren,
        },
      };

      // 3️⃣ 레벨1 이상의 자식들을 부모(children)에 연결
      const defaultParentId = parentId; // 문자열 그대로
      pastedNodeIds.forEach((id) => {
        const node = copyDataSource.items[id];
        // 레벨1만 루트 노드(children)에 추가
        if (
          (node.data?.original?.no_level ?? 0) === 1 &&
          newItems[defaultParentId]
        ) {
          newItems[defaultParentId] = {
            ...newItems[defaultParentId],
            children: [...(newItems[defaultParentId].children ?? []), id],
          };
        }
      });

      pastedNodeIds.forEach((id) => {
        const node = newItems[id];
        if (node) {
          newItems[id] = {
            ...node,
            data: {
              ...node.data,
              original: {
                ...node.data.original,
                cd_user, // 선택된 사용자로 변경
              },
            },
          };
        }
      });
      return { ...prev, items: newItems };
    });
    await showDialog("success", "붙여넣기 완료되었습니다.");
    setCopyDataSource([]);
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChangedH,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {},
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="w-full h-full flex flex space-x-2 overflow-x-auto overflow-y-hidden">
      <SnResizeBar direction={"width"} id="panel1" orgSize="24.5%">
        <div className="h-full flex flex-col ">
          <div className="h-full flex flex-col space-y-2">
            <SnResizeBar direction={"height"} id="panel2" orgSize="49.5%">
              <SnGrid
                ref={gridRefs.current["grid1"]} // Grid Name
                columnConfig={grids.grid1.columns} // 컬럼 설정 전달
                rowData={grids.grid1.dataSource} // Datasource
                etcProps={{ rowSelection: "single", title: "그룹" }}
                events={grids.grid1.events}
              />
            </SnResizeBar>

            <SnResizeBar direction={"height"} id="panel3" orgSize="49.5%">
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                etcProps={{ rowSelection: "single", title: "사용자 List" }}
                events={grids.grid2.events}
              />
            </SnResizeBar>
          </div>
        </div>
      </SnResizeBar>
      {treeDataSource?.items?.root_1 && (
        <ControlledTreeEnvironment
          items={mergedItems}
          getItemTitle={(item) => item.data.title}
          canDragAndDrop={true}
          canDropAt={(items, target) => {
            // tree1에 드롭 불가
            if ("treeId" in target && target.treeId === "tree") {
              return false;
            }
            return true;
          }}
          canReorderItems={true}
          canDropOnFolder={true}
          canDropOnNonFolder={false}
          onSelectItems={(items, treeId) => {
            setSelectedItems(items); // 선택된 노드 ID 배열 저장
          }}
          viewState={{
            tree: {
              selectedItems: selectedItems,
              expandedItems: expandedItems,
            },
            tree2: {
              selectedItems: selectedItems,
              expandedItems: expandedItems2,
            },
          }}
          onExpandItem={(item, treeId) => {
            if (treeId === "tree") {
              setExpandedItems((prev) => [...prev, item.index]);
            } else if (treeId === "tree2") {
              setExpandedItems2((prev) => [...prev, item.index]);
            }
          }}
          onCollapseItem={(item, treeId) => {
            if (treeId === "tree") {
              setExpandedItems((prev) =>
                prev.filter((id) => id !== item.index)
              );
            } else if (treeId === "tree2") {
              setExpandedItems2((prev) =>
                prev.filter((id) => id !== item.index)
              );
            }
          }}
          onDrop={(draggedItems, target) => {
            if ("treeId" in target && target.treeId === "tree2") {
              handleDropToTree2(
                draggedItems as TreeItemData[], // 1. 드래그된 아이템 배열
                target, // 2. 드롭 위치 정보가 담긴 객체
                treeDataSource2.items, // 3. 트리2의 현재 아이템 데이터 (TreeData 타입)
                setTreeDataSource2, // 4. 트리2 상태를 업데이트하는 함수 (setState)
                treeDataSource.items, // 5. 트리1의 현재 아이템 데이터 (TreeData 타입)
                setTreeDataSource // 6. 트리1 상태를 업데이트하는 함수 (setState)
              );
            }
          }}
        >
          <SnResizeBar direction={"width"} id="panel4" orgSize="24.5%">
            <SnTab
              titles={["미할당메뉴"]}
              header={[
                <SnTabHeader
                  key="header2"
                  body={[
                    <SnButton
                      key="expand"
                      text={allExpanded ? "Collapse" : "Expand"}
                      onClick={() => toggleAll("tree1")}
                    />,
                  ]}
                />,
              ]}
              body={[
                <div
                  key="tree1-container"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    height: "100%",
                    overflow: "auto",
                  }}
                >
                  <Tree treeId="tree" rootItem="root_1" treeLabel="Menu Tree" />
                </div>,
              ]}
            />
          </SnResizeBar>

          <SnResizeBar direction={"width"} id="panel5" orgSize="24.5%">
            <SnTab
              titles={["그룹메뉴"]}
              header={[
                <SnTabHeader
                  key="header2"
                  body={[
                    // <SnButton
                    //   key="reset"
                    //   text="초기화"
                    //   onClick={() => reset()}
                    // />,
                    <SnButton
                      key="expand"
                      text={allExpanded2 ? "Collapse" : "Expand"}
                      onClick={() => toggleAll("tree2")}
                    />,
                  ]}
                />,
              ]}
              body={[
                <div
                  key="tree2-container"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    height: "100%",
                    overflow: "auto",
                  }}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    if (selectedItems.length > 0) {
                      setContextMenuPos({ x: e.clientX, y: e.clientY });
                      setContextMenuNode(selectedItems[0].toString()); // ID 문자열 저장
                    }
                  }}
                  onClick={() => {
                    setContextMenuPos(null);
                    setContextMenuNode(null);
                  }}
                >
                  <Tree
                    treeId="tree2"
                    rootItem="root_2"
                    treeLabel="Menu Tree"
                  />
                </div>,
              ]}
            />
          </SnResizeBar>
        </ControlledTreeEnvironment>
      )}
      {treeDataSource3?.items?.root_3 && (
        <ControlledTreeEnvironment
          items={treeDataSource3.items}
          getItemTitle={(item) => item.data.title}
          onExpandItem={(item, treeId) => {
            setExpandedItems3((prev) => [...prev, item.index]);
          }}
          onCollapseItem={(item, treeId) => {
            setExpandedItems3((prev) => prev.filter((id) => id !== item.index));
          }}
          viewState={
            treeDataSource3?.items?.root_3
              ? { tree3: { expandedItems: expandedItems3 } }
              : {}
          }
        >
          <SnResizeBar direction={"width"} id="panel6" orgSize="24.5%">
            <SnTab
              titles={["회사메뉴"]}
              header={[
                <SnTabHeader
                  body={[
                    <SnTabHeader
                      body={[
                        <SnButton
                          key="expand"
                          text={allExpanded3 ? "Collapse" : "Expand"}
                          onClick={() => toggleAll("tree3")}
                        />,
                      ]}
                    />,
                  ]}
                />,
              ]}
              body={[
                <div
                  key="tree3-container"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    height: "100%",
                    overflow: "auto",
                  }}
                >
                  <Tree
                    treeId="tree3"
                    rootItem="root_3"
                    treeLabel="Menu Tree"
                  />
                </div>,
              ]}
            />
          </SnResizeBar>
        </ControlledTreeEnvironment>
      )}
      {contextMenuPos && contextMenuNode && (
        <div
          style={{
            position: "fixed",
            top: contextMenuPos.y,
            left: contextMenuPos.x,
            backgroundColor: "white",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            zIndex: 1000,
            padding: "6px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            fontFamily: "'Malgun Gothic', '맑은 고딕', Arial, sans-serif",
            fontSize: "13px",
            color: "#333",
            lineHeight: "1.6",
            transition: "background-color 0.2s ease",
          }}
          onMouseLeave={closeContextMenu}
        >
          {(() => {
            const nodeId = selectedItems[0];
            const nodeData = treeDataSource2?.items?.[nodeId];
            const no_level = nodeData?.data?.original?.no_level;

            if (no_level === undefined) return null;

            // 레벨 0 노드
            if (no_level === 0) {
              return (
                <>
                  {/* 전권설정 */}
                  <div
                    onClick={() => {
                      assignAllPermissions();
                      closeContextMenu();
                    }}
                  >
                    전권설정
                  </div>

                  {/* 전권해제 */}
                  <div
                    onClick={() => {
                      reset();
                      closeContextMenu();
                    }}
                  >
                    전권해제
                  </div>

                  {/* 권한복사 */}
                  <div
                    onClick={() => {
                      copyPermissions();
                      closeContextMenu();
                    }}
                  >
                    권한복사
                  </div>

                  {/* 권한붙여넣기 */}
                  <div
                    onClick={() => {
                      if (!copyDataSource || copyDataSource.length === 0) {
                        alert("복사된 권한이 없습니다.");
                        return;
                      } else {
                        pastePermissions(copyDataSource);
                      }
                      closeContextMenu();
                    }}
                  >
                    권한붙여넣기
                  </div>
                </>
              );
            }

            // 레벨 >0 노드
            return (
              <div
                onClick={() => {
                  onDeleteRow(nodeId);
                  closeContextMenu();
                }}
              >
                메뉴 권한 제거
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
});
export default SN_SYS_AUT_REG_001;
